export default {
  type: 'form_submission',
  widget: 'FormSubmissionWidget',
  engagement: true,
  feature: 'forms',
  icon: 'formSubmission',
  title: 'Add Form',
  help: 'Embed a ConveYour form for the learner to fill out.',
  schema: {
    form_record_id: {
      type: 'Select',
      title: 'Form',
      help: 'Select the form the learner will complete within this lesson.',
      validators: ['required'],
    },

    skip_if_exists: {
      type: 'Checkbox',
      title: 'Skip if Form Already Exists',
      help: 'Do not add the form if the contact already has one.',
      default: true,
    },

    time_horizon_days: {
      type: 'Number',
      title: 'Lookback Period (Days)',
      help: 'How many days back to check for an existing form.',
      default: 0,
      showOnHaving: 'skip_if_exists',
    },

    button_text: {
      type: 'Text',
      title: 'Button Text',
      help: 'Text shown on the button to open the form.',
      default: 'Complete Form',
    },

    can_advance: {
      type: 'Checkbox',
      default: false,
      title: 'Can Skip. Do not require.',
      help: 'Allow learner to advance without submitting the form.',
    },
  },
};
